import React, { useEffect } from "react";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router";
import { useInView } from "react-intersection-observer";
import { useDispatch, useSelector } from "react-redux";
import useSWRInfinite from "swr/infinite";
import useSWR from "swr";

// import Replayed from "./../Replayed/index";
import {
  getPlayerState,
  setPlayList,
} from "../../../../redux/features/playerSlice";
import { setLoadNavigation } from "../../../../redux/features/settingSlice";
import TopicLoadingCart from "../TopicLoadingCart";
import UseWindowDimensions from "../../../../utils/windowSize";
import TopicList from "../TopicList";
import EmptyState from "../../EmptyState";
import { ChunkTime, ChunkUser } from "./../../../../utils/ChunkWhile";
import { fetcherGetToken } from "../../../../services/fetcher";

const TopicCart = ({ type, data, openDes, setOpenDes }) => {
  const { minimizePlayer, playList } = useSelector(getPlayerState);
  const params = useParams();
  const location = useLocation();
  let urlParams = location.pathname.split("/");
  const dispatch = useDispatch();
  const { height } = UseWindowDimensions();
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;

  const { data: table } = useSWR(() => {
    return [
      `${process.env.REACT_APP_API}/content/table/${params.tableId}/`,
      tokenStorage,
    ];
  }, fetcherGetToken);

  // let mode = [146, 166, 198];

  const { ref: refTop, inView: vTop } = useInView({
    threshold: 0,
  });

  const { ref: refDown, inView: vDown } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (vTop) {
      setOpenDes(true);
      return;
    }
    const timeFunc = setTimeout(() => {
      if (!vTop) {
        setOpenDes(false);
        return;
      }
    }, 280);

    return () => {
      clearTimeout(timeFunc);
    };
  }, [setOpenDes, vTop]);
  // useEffect(() => {
  //   if (vTop) {
  //     setOpenDes(true);
  //     return;
  //   }
  //   const timeFunc = setTimeout(() => {
  //     if (!vTop) {
  //       setOpenDes(false);
  //       return;
  //     }
  //   }, 280);

  //   return () => {
  //     clearTimeout(timeFunc);
  //   };
  // }, [setOpenDes, vTop]);

  // useEffect(() => {
  //   topicSwipe(setOpenDes);
  // }, [setOpenDes]);

  const conditionalReq = () => {
    let mode = null;

    if (type === "opinion") {
      mode = `/content/topics/${params.opinionId}/`;
    } else {
      mode = `/content/converses/${params.discussionId}/`;
    }

    return mode;
  };

  const {
    data: topic,
    isLoading,
    size,
    setSize,
    isValidating,
  } = useSWRInfinite(
    (pageIndex, previousPageData) => {
      if (previousPageData && !previousPageData.results.length) return null;

      return [
        `${process.env.REACT_APP_API + conditionalReq()}?page=${pageIndex + 1}`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    {
      revalidateFirstPage: true,
      initialSize: 1,
    }
  );

  useEffect(() => {
    !isLoading && dispatch(setLoadNavigation(isValidating));
  }, [dispatch, isLoading, isValidating]);

  useEffect(() => {
    vDown && moreInfinite();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vDown]);

  const moreInfinite = () => {
    if (topic) {
      const moreTopicCart = size + 1 <= topic[0]?.total_pages;
      if (moreTopicCart) {
        setSize(size + 1);
        dispatch(setLoadNavigation(true));
      } else {
        // setSize(topic[0].total_pages);
      }
    }
  };

  useEffect(() => {
    if (topic) {
      let topicList = [];
      // eslint-disable-next-line array-callback-return
      topic.map((e) => {
        topicList.push(...e.results);
      });
      dispatch(setPlayList(topicList));
    }
  }, [dispatch, topic]);

  // const date = new Date(2009, 10, 10); // 2009-11-10
  const month = (date) => {
    return date.toLocaleString("default", { month: "long" });
  };

  return (
    <>
      <Box
        sx={{
          position: "relative",
          overflowY: "scroll",
          width: "100%",
          // height: `calc(${height}px - 260px)`,
          height: height - 204 - (minimizePlayer ? 82 : 0) + "px",
          mt: "8px",
        }}
      >
        <Box
          ref={refTop}
          sx={{ display: "flex", justifyContent: "center", py: "1px" }}
        ></Box>
        {/* <Typography
          sx={{
            fontSize: "16px",
            color: "black.main",
            lineHeight: "24px",

            mb: "18px",
            direction: RightLeftChecker(data?.description) ? "rtl" : "ltr",
          }}
        >
          {data?.description}
        </Typography> */}
        <Box
          sx={{
            borderBottom: "2px solid",
            borderColor: "black.main",
            // mb: "20px",
            mt: "-2px",
            position: "sticky",
            top: 0,
          }}
        ></Box>

        {(isLoading || !topic) && <TopicLoadingCart type={type} />}
        {!isLoading &&
          playList &&
          ChunkTime(playList).map((rowD, ind) => {
            return (
              <Box key={ind} sx={{ my: "8px" }}>
                {type !== "opinion" && (
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "11px",
                      mt: "2px",
                      textAlign: "center",
                      color: "mute.main",
                    }}
                  >
                    {month(new Date(rowD[0]?.created_at))}{" "}
                    {new Date(rowD[0]?.created_at).getDate()}
                  </Typography>
                )}

                {ChunkUser(rowD).map((rowData, index) => {
                  return (
                    <Box key={index} sx={{ my: "8px" }}>
                      {rowData.map((row, i, { length }) => {
                        return (
                          <TopicList
                            key={i}
                            rowData={row}
                            type={type}
                            firstIndex={i === 0}
                            lastIndex={i + 1 === length}
                          />
                        );
                      })}
                    </Box>
                  );
                })}
              </Box>
            );
          })}

        {!isLoading && topic && playList.length === 0 && (
          <EmptyState
            title='There is no topics posted on this opinion yet'
            dis={
              table?.enrolled
                ? `You can view other ${
                    urlParams[3] === "opinions"
                      ? "opinions, Or discussions"
                      : "discussions, Or opinions"
                  }.`
                : `Enroll in this table to inform about updates! Or view other ${urlParams[3]}.`
            }
            btn1={
              table?.enrolled
                ? urlParams[3] === "opinions"
                  ? "opinions"
                  : "discussions"
                : urlParams[3] === "opinions"
                ? "discussions"
                : "opinions"
            }
            btn2={
              table?.enrolled
                ? urlParams[3] === "opinions"
                  ? "discussions"
                  : "opinions"
                : "enroll"
            }
          />
        )}

        <Box
          ref={refDown}
          sx={{ display: "flex", justifyContent: "center", py: "3px" }}
        ></Box>
      </Box>
    </>
  );
};

export default TopicCart;
